module.exports = __webpack_public_path__ + "img/grass.231c059a.png";